module.exports = __webpack_public_path__ + "static/img/ba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/indexImg/ba.png
// module id = FDnu
// module chunks = 8